import { shallow } from 'zustand/shallow';
import { useStore } from '../store/useStore';

// Simple check if there are colliding props and selectors
const hasUniqueKeys = (props: any, store: any) => {
	const propKeys = Object.keys(props);
	const selectorKeys = Object.keys(store);
	const set = new Set([...propKeys, ...selectorKeys]);

	return set.size === propKeys.length + selectorKeys.length;
};

const withState = (selectors: any) => (BaseComponent: any) => (props: any) => {
	const store = useStore<any>(selectors, shallow);
	if (!hasUniqueKeys(props, store)) {
		console.warn('ONE OR MORE ZUSTAND SELECTORS COLLIDE WITH PROPS');
	}
	return <BaseComponent {...props} {...store} />;
};

export default withState;
